import { render, staticRenderFns } from "./ProfileView.vue?vue&type=template&id=0b148c06&scoped=true"
import script from "./ProfileView.vue?vue&type=script&setup=true&lang=ts&generic=T"
export * from "./ProfileView.vue?vue&type=script&setup=true&lang=ts&generic=T"
import style0 from "./ProfileView.vue?vue&type=style&index=0&id=0b148c06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b148c06",
  null
  
)

export default component.exports